import CityPageToldos from "../components/CityPageToldos";

export default function ToldosMijas() {
  return (
    <CityPageToldos
      name="Mijas"
      slug="mijas"
      cp="29649, 29650, 29651"
      poblacion={94320}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5953}
      lng={-4.6371}
      zonas={["Mijas Costa", "La Cala de Mijas", "Calahonda", "Riviera del Sol", "Las Lagunas"]}
      landmarks={["Hipódromo Costa del Sol", "Mijas Pueblo"]}
      municipiosLimitrofes={["Fuengirola", "Benalmádena", "Marbella"]}
      festivalLocal="Feria de Mijas, segunda semana de septiembre"
      contextoTipologico="Urbanizaciones modernas La Cala-Calahonda con villas, casas tradicionales en el pueblo, restaurantes con toldos comerciales."
      isCoreZone={true}
    />
  );
}